import React, { useEffect } from 'react';
import { useForm, FieldValues } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import { resetError } from '../../../../actions/auth';

import {
  InputEmail,
  InputPassword,
  ErrorField,
} from '../../../../lib/HooksFormFields';

import styles from './signin-form.module.scss';

interface ISignInForm {
  errorMessage?: string,
  registerLink?: string,
  forgotPwdLink?: string,
  submit: (data: FieldValues) => void,
}

const SignInForm = ({
  errorMessage,
  registerLink,
  forgotPwdLink,
  submit,
}: ISignInForm) => {
  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const watchEmail = watch('email');
  const watchPassword = watch('password');

  useEffect(() => resetError(dispatch), []);

  useEffect(() => {
    if (errorMessage) resetError(dispatch);
  }, [watchEmail, watchPassword]);

  function onSubmit(data: FieldValues) {
    submit(data);
  }

  function handlePressEnter(e: React.KeyboardEvent) {
    if (e.key === 'Enter') {
      handleSubmit(onSubmit)();
    }
  }

  return (
    <div className={styles['signin-form']}>
      {registerLink
        && (
        <div className={styles['container-link']}>
          <p>
            Pas encore de compte ?
            {' '}
            <NavLink to={registerLink}>Créer un compte</NavLink>
          </p>
        </div>
        )}
      <div className={styles.form} onKeyDown={handlePressEnter}>
        <div className={styles['container-field']}>
          <InputEmail
            name="email"
            control={control}
            required
            label="Adresse email"
            className="login"
          />
          {errors.email && <ErrorField message={errors.email.message} />}
        </div>
        <div className={styles['container-field']}>
          <InputPassword
            name="password"
            control={control}
            required
            requiredMessage="Veuillez saisir votre mot de passe"
            label="Mot de passe"
            className="login"
          />
          {errors.password && <ErrorField message={errors.password.message} />}
        </div>
        {(!errors.email && !errors.password) && errorMessage
          && (
          <p className={styles['message-error']}>
            {errorMessage}
          </p>
          )}
      </div>
      <div className={styles.containerSubmit}>
        <div className={styles.containerBtn}>
          <button onClick={handleSubmit(onSubmit)}>Me connecter</button>
          <a href={`${process.env.REACT_APP_API_URL}/auth/login-sso`}>
            <button >SSO</button>
          </a>
          {/* <a href={`${process.env.REACT_APP_API_URL}/auth/test-sso`}>
            <button >Test SSO</button>
          </a> */}
        </div>
        {forgotPwdLink && (
        <NavLink to={forgotPwdLink}>
          Mot de passe oublié ?
        </NavLink>
        )}
      </div>
    </div>
  );
};

SignInForm.propTypes = {
  submit: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
};

export default SignInForm;
